@if (previewMode$ | async) {
  <div class="preview-band">
    {{ 'voting.portal_preview' | translate }}
  </div>
}
<div class="root-wrapper">
  <router-outlet></router-outlet>
</div>
